/**
 * Cửa vào màn khách: đọc token từ đường dẫn.
 *
 * Khác màn iPad, token KHÔNG bị lau khỏi thanh địa chỉ. Hai màn có hai hoàn
 * cảnh khác nhau: iPad là máy dùng chung ở quầy, ai liếc qua cũng chép được vé;
 * còn link album mở trên máy của chính khách, và khách cần giữ lại để mở lại
 * lần sau.
 */
import { useParams } from "@tanstack/react-router";
import { CustomerAlbumPage } from "./CustomerAlbumPage";
import { PublicPageScroll } from "@/components/PublicPageScroll";

export function AlbumShareRoute() {
  const { token } = useParams({ from: "/album/$token" });
  return (
    <PublicPageScroll>
      <CustomerAlbumPage token={token} />
    </PublicPageScroll>
  );
}
